<template>
  <transition name="modal-backdrop-transition" appear>
    <div class="o-backdrop" @click="close()">
      <button
        type="button"
        class="modal__close --is-mobile-close"
        @click.stop="close()"
        v-if="$store.getters.isMobile"
      >
        <i class="icon icon-times"></i>
      </button>
      <transition name="modal-content-transition" appear>
        <div class="modal --is-content" @click.stop>
          <div class="modal__scrollable">
            <!-- modal body content -->
            <h2 v-html="isLoaded ? content.title.rendered : ''"></h2>
            <div
              v-if="isLoaded"
              v-html="content.content.rendered"
              class="modal-external-content__body"
            >
            </div>

            <div
              v-else
              class="modal-external-content__body"
            >
              <div class="o-loader">
                <div class="o-loader__ring"><div></div><div></div><div></div><div></div></div>
              </div>
            </div>
            <!-- /modal body content -->
          </div>

          <button
            type="button"
            class="modal__close"
            @click.stop="close()"
            v-if="!$store.getters.isMobile"
          >
            <i class="icon icon-times"></i>
          </button>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ModalExternalContent',
  components: {
  },
  props: {
    url: {
      type: String
    }
  },
  data: function () {
    return {
      error: false,
      isLoaded: false,
      content: null
    };
  },
  methods: {
    close () {
      this.$parent.modal = null;
      this.$parent.modalUrl = null;
    },
    escKeyHandler (e) {
      if (this.$parent.modal && e.keyCode === 27) {
        this.close();
      }
    }
  },
  created () {
    if (this.url) {
      let slug = new URL(this.url).pathname.match(/.*?\/composer-knowledgebase\/([^?]*)/);

      if (slug) {
        slug = slug[1].replace('/', '');
      } else {
        slug = null;
      }

      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/wp-json/wp/v2/pages?slug=${slug}`
        )
        .then((response) => {
          if (!response.data.length) {
            this.error = true;
          }

          if (response.data[0]) {
            this.content = response.data[0];

            // Ugly hack to remove any "elementor-col" classes because of Gridlex depency collision
            this.content.content.rendered = this.content.content.rendered.replace(/col-/g, '');

            this.isLoaded = true;
          }
        });
    }
  },
  mounted: function () {
    // Esc key for closing modal
    document.addEventListener('keydown', this.escKeyHandler, { once: true });

    document.body.style.setProperty('overflow', 'hidden');
  },
  destroyed () {
    document.removeEventListener('keydown', this.escKeyHandler);

    document.body.style.setProperty('overflow', 'visible');
  },
};
</script>

<style lang="scss" scoped>
/**
 * External Conent Modal
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc For showing content coming from WP
 * @since 2022-04-10
**/

$component: 'modal-external-content';

.#{$component} {
  &__body {
    .wp-block-image {
      margin-left: auto;
      margin-right: auto;
      outline: 1px solid red;
    }
  }
}
</style>

<style lang="scss">
@import '../../assets/styles/components/modal';
</style>
